import {
  LayoutDashboard,
  ListChecks,
  NotebookPen,
  Users,
  Calendar,
  Calculator,
  ShoppingBasket,
  User,
  TrendingUp,
  Layers,
  Box,
  Shield,
  Settings,
  Warehouse,
  BookOpen,
  UserCheck,
  Truck,
  Globe,
} from "lucide-react"


// --- TYPY ---
export type NavSection = "Główne" | "Inne" | "Zarządzanie" | "System"

export interface NavLink {
  href: string
  label: string
  icon: React.ComponentType<{ className?: string }>
  badge?: string
  adminOnly?: boolean
  developerOnly?: boolean
  section: NavSection
}

export interface NavSubLink {
  href: string
  label: string
}

export interface NavGroup {
  id: string
  label: string
  icon: React.ComponentType<{ className?: string }>
  section: NavSection
  children: NavSubLink[]
  /** If any child is active, group can't be closed */
  lockOpenWhenActive?: boolean
}

export const NAV_GROUPS: NavGroup[] = [
  {
    id: "katalog-maszyn",
    label: "Katalog WWW",
    icon: Globe,
    section: "Główne",
    lockOpenWhenActive: true,
    children: [
      { href: "/katalog-maszyn", label: "Wszystkie maszyny" },
      { href: "/katalog-maszyn/new", label: "Dodaj maszynę" },
      { href: "/katalog-maszyn/kategorie", label: "Kategorie maszyn" },
    ],
  },
  {
    id: "podrecznik",
    label: "Podręcznik",
    icon: BookOpen,
    section: "Inne",
    lockOpenWhenActive: true,
    children: [{ href: "/podrecznik/waly", label: "Wały" }],
  },
]

export const NAV_LINKS: NavLink[] = [
  { href: "/", label: "Dashboard", icon: LayoutDashboard, section: "Główne" },
  { href: "/activity", label: "Aktywność", icon: Layers, section: "Główne" },
  { href: "/notes", label: "Notatki", icon: NotebookPen, section: "Główne" },
  { href: "/admin/tasks", label: "Zadania", icon: ListChecks, section: "Główne" },
  { href: "/assignments", label: "Przydziały", icon: UserCheck, section: "Główne" },
  { href: "/orders", label: "Zamówienia", icon: ShoppingBasket, section: "Główne" },
  { href: "/calendar", label: "Kalendarz", icon: Calendar, section: "Główne" },
  { href: "/magazyn", label: "Magazyn", icon: Warehouse, section: "Główne" },
  { href: "/machines", label: "Maszyny", icon: Settings, section: "Główne" },
  { href: "/admin/clients", label: "Klienci", icon: Users, section: "Główne" },
  { href: "/suppliers", label: "Dostawcy", icon: Truck, section: "Główne" },


  { href: "/board", label: "Tablica", icon: Layers, section: "Inne" },
  { href: "/calculator", label: "Kalkulator", icon: Calculator, section: "Inne" },
  { href: "/kalkulatorwag", label: "Kalkulator Stali", icon: Calculator, section: "Inne" },
  { href: "/cutCalculator", label: "Kalkulator Cięcia", icon: Calculator, section: "Inne" },
  { href: "/projects3d", label: "Projekty 3D", icon: Box, section: "Inne" },

  { href: "/admin/users", label: "Użytkownicy", icon: User, adminOnly: true, section: "Zarządzanie" },
  { href: "/stats", label: "Statystyki", icon: TrendingUp, section: "Zarządzanie" },
  { href: "/developer", label: "Developer", icon: Shield, developerOnly: true, section: "Zarządzanie" },
]

export const SECTIONS: NavSection[] = ["Główne", "Inne", "Zarządzanie", "System"]

export function filterNavLinks(links: NavLink[], opts: { isAdmin: boolean; isDeveloper: boolean }) {
  return links.filter((link) => {
    if (link.adminOnly && !opts.isAdmin) return false
    if (link.developerOnly && !opts.isDeveloper) return false
    return true
  })
}

export function isActivePath(pathname: string, href: string) {
  return href === "/" ? pathname === href : pathname.startsWith(href)
}

export function isGroupChildActive(childHref: string, pathname: string): boolean {
  if (childHref === "/katalog-maszyn") {
    return pathname === "/katalog-maszyn"
  }
  return pathname.startsWith(childHref)
}
